// extracted by mini-css-extract-plugin
export var categoryIcon = "_df-5";
export var connectorContainer = "_df-1";
export var connectorLine = "_df-0";
export var minHeight0 = "_df-6";
export var relativeUnitValueSelector = "_df-2";
export var trifoldSelectorBody = "_df-4";
export var trifoldSelectorList = "_df-3";